import React from 'react';
import { Padding, Stack, Text } from '../../components';

export const lifeAtGlossierData = [
  {
    title: 'Paid Volunteer Time',
    description:
      'Our Smile Wave Volunteer Time Off (“VTO”) program is to encourage our employees to get involved in the causes that matter most to them. We offer 4 days per calendar year for employees to volunteer.',
  },
  {
    title: 'Culture & Community',
    description:
      'We focus on social impact internally and externally, and foster a values-driven culture. We also offer monthly team-building events and company celebrations.',
  },
  {
    title: 'Intracompany committees',
    description:
      'We offer Employee Resource Groups (ERGs) to connect and empower like-minded employees to invoke and encourage meaningful conversations and action at Glossier.',
  },
];

export const lifeAtGlossierImages = [
  'images/life-at-glossier-picture-1.jpg',
  'images/life-at-glossier-picture-2.jpg',
  'images/life-at-glossier-picture-3.jpg',
];

export const LifeAtGlossierComponent = (props) => {
  let { value } = props;
  let { title, description } = value || {
    title: '',
    description: '',
  };
  return (
    <Padding size={[2, 4]}>
      <Stack size={3}>
        <Text textType="primary1" align="left">
          {title}
        </Text>
        <Text textType="primary2" align="left">
          {description}
        </Text>
      </Stack>
    </Padding>
  );
};
